import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { MemoryService } from "../_services/memory.service";
import { TestService } from "../_services/test.service";
@Injectable({ providedIn: "root" })
export class AuthCheck implements CanActivate {
  agentCheck: boolean;
  loginData: any;
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private memoryService: MemoryService,
    private testService: TestService
  ) {
    this.memoryService.getAgentCheck().subscribe((data) => {
      this.agentCheck = data;
    });
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.agentCheck) {
      return true;
    }
    const currentUser =
      this.cookieService.get("loginSubscriptionData") != ""
        ? JSON.parse(this.cookieService.get("loginSubscriptionData"))
        : undefined;
    if (currentUser) {
      if (!(currentUser.access_token)) {
        // no logged user, redirect to /login
        this.router.navigate(["/login"]);
        return false;
      }
      // authorised so return true
      return true;
    } else if (currentUser == undefined) {
      this.cookieService.delete("loginSubscriptionData", "/");
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
